var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn",attrs:{"to":{ name: 'infographic', query: {pinNumber: _vm.pinNumber}, params: {back_page: _vm.back_page} }}},[_c('div',{staticClass:"row"},[_c('fixeau-head-devices',{staticClass:"col-10",attrs:{"values":_vm.values,"name":_vm.name,"pinNumber":_vm.pinNumber}}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }